import React from 'react';
import styles from './UploadFile.styles';
import { componentKey } from '../../BatchImportSlice';
import { useSelector } from 'react-redux';
import TabbedNavigation from '../../../../../components/tabbednavigation/TabbedNavigation';
import UploadFileView from './UploadFileView';
import PasteView from './PasteView';
import Loadable from '../../../../../components/loadable/Loadable';
import { BATCH_FORMS_LOADING_STATES } from '../../constants';

export default function UploadFile({setRefreshStep = () => {}}) {
	
	const { loadingState, uploadFileLoadingState, batchImportFormData, formSettings, isQuarterSelectionPopupOpen, quarterSelectionPopupTriggeredByModule }  = useSelector(state => state[componentKey]);

	const fileUploadTabList = [
        {
            title: "Upload",
			tabBodyComponent: <Loadable isNewLoadable={true} currentState={uploadFileLoadingState.state} loadingStates={[BATCH_FORMS_LOADING_STATES.GET_FORM_SETTINGS_LOADING]}> <UploadFileView loadingState={loadingState} batchImportFormData={batchImportFormData} setRefreshStep={(idx) => setRefreshStep(idx)} formSettings={formSettings} isQuarterSelectionPopupOpen={isQuarterSelectionPopupOpen} quarterSelectionPopupTriggeredByModule={quarterSelectionPopupTriggeredByModule} /> </Loadable>,
        }, {
            title: "Paste",
            tabBodyComponent: <PasteView loadingState={loadingState} batchImportFormData={batchImportFormData} setRefreshStep={(idx) => setRefreshStep(idx)} formSettings={formSettings} isQuarterSelectionPopupOpen={isQuarterSelectionPopupOpen} quarterSelectionPopupTriggeredByModule={quarterSelectionPopupTriggeredByModule} />,
        },
    ];

	return (
		<>
			<div style={styles.uploadScreenContainer}>
				<TabbedNavigation tabList={fileUploadTabList} />
			</div>
		</>
	)
}